import { render, staticRenderFns } from "./index--form.vue?vue&type=template&id=f63b3b8e&scoped=true&"
import script from "./index--form.vue?vue&type=script&lang=js&"
export * from "./index--form.vue?vue&type=script&lang=js&"
import style0 from "./index--form.vue?vue&type=style&index=0&id=f63b3b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63b3b8e",
  null
  
)

export default component.exports